import { mapDTO } from '@twistezo/ts-dto-mapper'

import { ProposalsDataDTO } from 'features/globalSetup/api/types/gamOrderRetargetingDealsDeliveryDTO'
import { ProposalIdItem } from 'features/globalSetup/types/gamOrderRetargetingDealsDelivery'
import { GamOrderRetargetingDealsDeliverySlice } from '../types'
import { GamOrderRetargetingDealsDeliverySliceDTO } from './types'

export const fromDTO = (
  from: GamOrderRetargetingDealsDeliverySliceDTO,
): GamOrderRetargetingDealsDeliverySlice =>
  mapDTO<GamOrderRetargetingDealsDeliverySliceDTO, GamOrderRetargetingDealsDeliverySlice>({
    from,
  }).transform(
    (dto: GamOrderRetargetingDealsDeliverySliceDTO): GamOrderRetargetingDealsDeliverySlice => {
      const { currency, errorMessage, geo, proposalsData, status } = dto

      return {
        currency: currency || undefined,
        errorMessage: errorMessage || undefined,
        geo: geo || undefined,
        proposalsData: proposalsData ? proposalsData.map(proposalItemFromDTO) : [],
        status: status,
      }
    },
  )

const proposalItemFromDTO = (from: ProposalsDataDTO): ProposalIdItem =>
  mapDTO<ProposalsDataDTO, ProposalIdItem>({ from }).transform(
    (dto: ProposalsDataDTO): ProposalIdItem => {
      const { maxPrice, minPrice, proposalId, step } = dto

      return {
        maxPrice,
        minPrice,
        proposalId: proposalId.toString(),
        step,
      }
    },
  )
